<template>
  <Modal 
    @close="$emit('close')"
    width="400px"
    :hasCloseButton="!necessarily"
  >
    <Form @request="changePassword">
      <h2 style="margin-bottom: 24px">Изменить пароль</h2>
      <VInput
        type="password"
        v-model="newPassword"
        name="newPassword"
        required
        placeholder="Новый пароль"
        style="margin-bottom: 8px"
        :pattern="pattern"
      >
        <Validation :absolute="false" for="pattern">{{ validationText }}</Validation>
      </VInput>
      <VInput
        type="password"
        :sameAs="newPassword"
        name="repeatPassword"
        required
        placeholder="Повторите пароль"
        style="margin-bottom: 24px"
      >
        <Validation :absolute="false" for="sameAs">Пароли не совпадают</Validation>
      </VInput>
      <Button
        :loading="changePasswordLoading"
        class="btn-primary"
        width="100%"
        height="48px"
        text="Сохранить"
        style="margin-bottom: 16px"
      />
      <Button
        v-if="!necessarily"
        @click.native.prevent="$emit('close')"
        class="btn-secondary"
        width="100%"
        height="48px"
        text="Отменить"
      />
    </Form>
  </Modal>
</template>

<script>
import Modal from "@/components/Modals/Modal.vue";
import Button from "@/components/Button.vue";
import Form from "@/components/Form/Form.vue";
import VInput from "@/components/Form/Vinput/Vinput.vue";
import Validation from "@/components/Form/Validation.vue";
import { getSettings } from "@/api/settings";
export default {
  components: {
    Modal,
    Button,
    Form,
    VInput,
    Validation
  },
  data() {
    return {
      changePasswordLoading: false,
      newPassword: "",
      pattern: "",
      validationText: "",
    };
  },
  props: {
    request: {
      type: Function,
      default: () => {},
    },
    necessarily: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async changePassword(passwordData) {
      this.changePasswordLoading = true;
      try {
        await this.request(passwordData);
      } catch (err) {
        Promise.reject(err);
      }
      this.changePasswordLoading = false;
      this.$emit("close");
    },

    convert (array) {
      // Опции для паттерна проверки пароля
      const { length, uppercase, lowercase, numbers: number, symbols: symbol } = array.reduce(
        (acc, item) => ({
          ...acc,
          [item.name]: item,
        }),
        {}
      );

      this.validationText = "Пароль должен состоять из " + length.value  + " или более символов"
      this.pattern = '^';

      const anyChecked = [uppercase, lowercase, number, symbol].some(({ value }) => value === "1");
      if (anyChecked) {
        this.validationText += " и содержать";
      }

      if (uppercase.value === "1") {
        this.pattern += '(?=.*[A-Z])';
        this.validationText = this.validationText + ", заглавные буквы (A-Z)"
      }
      if (lowercase.value === "1") {
        this.pattern += '(?=.*[a-z])';
        this.validationText = this.validationText + ", строчные буквы (a-z)"
      }
      if (number.value === "1") {
        this.pattern += '(?=.*\\d)';
        this.validationText = this.validationText + ", цифры"
      }
      if (symbol.value === "1") {
        this.pattern += '(?=.*[!@#$%&?*<>_\\-.,:;^=+\\(\\)`~/{}|\\[\\]])';
        this.validationText = this.validationText + ", cимволы (!@#$%&?*<>_-.,:;^=+()`~/{}|\[])" // eslint-disable-line
      }
      this.pattern += '.{' + length.value + ',}.*';
      this.validationText = this.validationText.replace('содержать,', 'содержать');
    },
  },
  mounted() {
    getSettings().then((res) => this.convert(res))
  },
};
</script>
